import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Images } from '@constants/images';
import { Question } from '@models/questionnaire/question';
import { AbstractService } from '@services/abstract.service';
import { QuestionnaireQuestion } from "@models/questionnaire/questionnaire-question";
import { QuestionnaireQuestionChoise } from "@models/questionnaire/questionnaire-question-choise";
import { Questionnaire } from "@models/questionnaire/questionnaire";
import { QuestionType } from "@models/questionnaire/question-type";
import { QuestionTypeService } from "@services/admin/question-type.service";

@Component({
  standalone: false,
  selector: 'app-questionnaire-question-form',
  templateUrl: './questionnaire-question-form.component.html',
  styleUrls: ['./questionnaire-question-form.component.scss']
})
export class QuestionnaireQuestionFormComponent implements OnInit {
  @Input() service: AbstractService | null = null;
  // @ViewChild('showQuestion') showQuestion!: ElementRef;
  // @ViewChild('showFormQuestion') showFormQuestion!: ElementRef;
  public createBtnQuestion = 'cms.components.questionnaires.createBtnQuestion';
  public questions: QuestionnaireQuestion[] = []
  public questionSelected: QuestionnaireQuestion | null = null;
  public questionTypes: QuestionType[] = [];
  public createQuestion: QuestionnaireQuestion | null = null;
  public showFormChoices: boolean = true;
  private questionEdit!: number | null;
  private questionarieID = 0;
  public change: boolean =  false;
  public images = Images;

  preguntas: any[] = [];
  pregunta: Question = {
    answerA: '',
    answerB: '',
    image: '',
    question: '',
    questionType: ''
  };

  constructor(
    // private modal: NgbModal,
    private questionTypeService: QuestionTypeService
  ) {
    //this.setDefaultQuestion();
  }

  ngOnInit(): void {
    this.questionTypeService.getAll().then((data) => {
      if (data) {
        this.questionTypes = this.questionTypeService.data.data;
      }
    });
    if (this.service !== null) {
      if (this.questions !== this.service.modelClass.model['questionnaireQuestions']) {
        this.questions = this.service.modelClass.model['questionnaireQuestions'];
        this.questionarieID = this.service.modelClass.model['questionnaireID'];
      }
    }
  }

  public setDefaultQuestion = () => this.createQuestion = {
    questionnaireQuestionID: 0,
    questionnaireID: this.questionarieID,
    questionTypeID: 0,
    txtQuestion: '',
    questionnaireAnswerType: '',
    isMandatory: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: '',
    questionnaireQuestionChoises: [],
    questionnaire: null,
    /*questionnaire: {
      questionnaireID: this.questionarieID,
      tenantID: 0,
      title: '',
      description: '',
      startDate: new Date,
      finishDate: new Date,
      isActive: true,
      questionnairesTypesId: 1,
      trainingID: 0,
      topicID: 0,
      workScheduleTypeID: 0,
      roleGroupID: 0,
      createdAt: new Date(),
      updatedAt: new Date(),
      createdBy: '',
      questionnaireQuestions: []
    },*/
    questionType: null
  };
  public setQuestionsToModel = () => {
    if (this.service !== null) {
      // @ts-ignore
      this.service.modelClass.model['questionnaireQuestions'] = this.questions;
    }
  }

  public closeQuestionModal = () => {
    this.questionSelected = null;
  }

  public closeModal = () => {
    this.createQuestion = null;
  }

  openModal(content: any) {
    /* this.modal.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result
      .then((result) => { },
        (reason) => { });
        */
  }

  public openQuestion = (q: QuestionnaireQuestion) => {
    this.questionSelected = q;
    // this.openModal(this.showQuestion);
  }

  public openFormQuestion = () => {
    this.questionEdit = null;
    this.setDefaultQuestion();
    // this.openModal(this.showFormQuestion);
  }

  public openFormUpdate = (question: QuestionnaireQuestion) => {
    this.questionEdit = this.questions.indexOf(question);
    //console.log(this.questionEdit);
    this.createQuestion = question;
    // this.openModal(this.showFormQuestion);
  }

  // Choices
  public addChoiceToQuestion = () => {
    // this.showFormChoices = false;
    if (this.createQuestion !== null) {
      this.createQuestion.questionnaireQuestionChoises.push({
        questionnaireQuestionChoiseID: 0,// this.createQuestion.questionnaireQuestionChoises.length,
        questionnaireQuestionID: 0,
        txtChoise: '',
        isCorrectChoise: true,
        order: 1,
        createdAt: new Date(),
        updatedAt: new Date(),
        createdBy: '',
        questionnaireQuestion: {
          questionnaireQuestionID: 0,
          questionnaireID: this.questionarieID,
          questionTypeID: 0,
          txtQuestion: "",
          questionnaireAnswerType: "",
          isMandatory: true,
          createdAt: new Date(),
          updatedAt: new Date(),
          createdBy: "",
          questionnaireQuestionChoises: [],
          questionnaire: null,
          questionType: null
        }
      });
    }
    // this.showFormChoices = true;
  }

  public selectCorrectChoice = (choice: QuestionnaireQuestionChoise) => {
    if (this.createQuestion !== null) {
      this.createQuestion.questionnaireQuestionChoises.map((item) => {
        if (this.createQuestion?.questionTypeID === 1 && choice.isCorrectChoise) {
          item.isCorrectChoise = item.questionnaireQuestionChoiseID === choice.questionnaireQuestionChoiseID;
        }
      });
    }
  }
  public deleteChoice = (choice: QuestionnaireQuestionChoise) => {
    if (this.createQuestion !== null) {
      this.createQuestion.questionnaireQuestionChoises = this.createQuestion.questionnaireQuestionChoises.filter(x => x !== choice);
    }
  }

  public setValue = (choice: QuestionnaireQuestionChoise, event: any, i: number) => {
    if (this.createQuestion !== null) {
      if (this.createQuestion.questionnaireQuestionChoises.length > 0) {
        this.createQuestion.questionnaireQuestionChoises[i].txtChoise = event.target.value;
        console.log(this.createQuestion)
        console.log(this.createQuestion.questionnaireQuestionChoises);
      }
    }
  }
  // End Choices

  public addQuestion = () => {
    if (this.createQuestion !== null) {
      this.createQuestion.questionType = this.questionTypes.filter(x => x.questionTypeID == this.createQuestion?.questionTypeID)[0];
      if (this.service !== null) {
        if (this.questionEdit !== null) {
          this.questions[this.questionEdit] = this.createQuestion;
        } else {
          this.service.modelClass.model['questionnaireQuestions'].push(this.createQuestion);
        }
      }
      console.log(this.questions);
      // this.modal.dismissAll();
      this.setQuestionsToModel();
    }
    this.createQuestion = null;
  }

  public check = (event: any): boolean => {
    if (event.charCode == 46) {
      return false;
    }
    return true;
  }

  public deleteQuestion = (question: QuestionnaireQuestion) => {
    this.questions = this.questions.filter(x => x !== question);
    this.setQuestionsToModel();
  }
}
